export default __webpack_public_path__ + "static/media/mediaDefault.6c3e277a.png";